let api = {}
api.login = '/api/login';
api.dashBoard = {
    tableList: '/api/a1/pileresult',
    produceLine: '/api/a1/production',
    exports: '/api/a1/pileresult/export',
    select: '/api/a1/config',
    passingRate: '/api/a1/pileresult/passingRate',
    productList: '/api/a1/pileresult/findByAccount',
    getList: '/api/a1/pileInformation',
    factoryList: '/api/a1/factory/list',
    findByUser: '/api/a1/factoryUser/findByUser'
};

api.packCheck = {
    page: '/api/a1/packCheck/page',
    export: '/api/a1/packCheck/export',
}

api.packLine = {
    list: '/api/a1/packLine/list',
    export: '/api/a1/packLine/export',
}

api.packGroup = {
    list: '/api/a1/packGroup/list',
}

api.avatarImport = {
    list:'/api/a1/pileExport/page',
    module:'/api/a1/pileExport/exportmod',
    upload:'/api/a1/avatar/addPileExport',
    pushDel:'/api/a1/avatar/addEquipmentInfo',
    del:'/api/a1/pileExport/delete/',
};

export default api;